import React from 'react';

// Shown in the result column until a step is selected. The workbench is otherwise opaque on
// first open: three empty columns give no hint that retrieval is tag-scoped, or that a run can
// be made without spending a completion.
export default function TestingIntro() {
  return (
    <div>
      <h6 className="fw-semibold mb-2">What this is for</h6>
      <p className="small text-muted">
        This reproduces what the AI assistant does for a field engineer on one of your assets, and
        shows its working. Use it to find out why an answer was good, wrong, or missing — before a
        field engineer finds out for you.
      </p>

      <h6 className="fw-semibold mb-2 mt-4">How to use it</h6>
      <ol className="small text-muted ps-3 mb-0">
        <li className="mb-2">
          <strong>Pick an asset.</strong> Retrieval is scoped by that asset&apos;s tags, exactly as
          it is for a field engineer — a different asset sees different documents.
        </li>
        <li className="mb-2">
          <strong>Check what it can reach.</strong> The files list separates documents in tag scope
          from the ones actually retrievable. A file that failed indexing, or is not shared with
          field engineers, is in scope but contributes nothing — the usual reason for a confident
          &ldquo;I don&apos;t know&rdquo;.
        </li>
        <li className="mb-2">
          <strong>Ask a question and run.</strong> <em>Retrieve only</em> costs one embedding and no
          completion, so you can iterate on scoping cheaply. <em>Retrieve and answer</em> runs the
          full pipeline.
        </li>
        <li className="mb-0">
          <strong>Step through the operations.</strong> Each one shows what it produced: the query
          as rewritten, the fragments found and their distances, and the exact prompt sent to the
          model. Fragments the answer cited are marked.
        </li>
      </ol>

      <div className="alert alert-light border small mt-4 mb-0" role="note">
        <i className="bi bi-info-circle me-1" />
        The operation list is whatever the pipeline actually did. As retrieval grows — a second
        pass, a reranking step — those appear here as additional operations without this view
        changing.
      </div>
    </div>
  );
}
